import { RootState } from "../../reducers";

export const currentTabSelector = (state: RootState): number =>
  state.documentScreen.currentTab;
